import React, { useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { GoogleLogo, ArrowLeft, Warning } from "@phosphor-icons/react";
import { LOGO_URL } from "../../lib/api";
import { useAuth, startGoogleLogin } from "../../lib/auth";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const unauthorized = params.get("unauthorized") === "1";
  const error = params.get("error") === "1";

  useEffect(() => {
    if (!loading && user?.is_admin) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="admin-shell flex items-center justify-center p-6">
      <div className="fixed inset-0 bg-blueprint-grid-dark bg-[size:4rem_4rem] opacity-30 pointer-events-none" />
      <div className="relative w-full max-w-md bg-[#1f1f1f] border-2 border-atc-red p-10" data-testid="admin-login-card">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white font-heading uppercase tracking-widest text-xs mb-8" data-testid="back-to-site">
          <ArrowLeft size={14} weight="bold" /> Back to site
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="ATC" className="h-14 w-14 object-contain" />
          <div>
            <div className="font-display text-xl leading-none text-white">ATC ADMIN</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50 mt-1">Command Center</div>
          </div>
        </div>
        <h1 className="font-display text-4xl uppercase text-white leading-none">Sign in.</h1>
        <p className="text-white/60 mt-3 text-sm">
          Admin access only. Sign in with the Google account on the allowlist.
        </p>

        {unauthorized && (
          <div className="mt-6 border border-yellow-500/40 bg-yellow-500/10 text-yellow-200 p-4 text-sm flex gap-3" data-testid="unauthorized-msg">
            <Warning size={18} weight="bold" className="shrink-0 mt-0.5" />
            <div>
              Your Google account isn't on the admin allowlist yet. Ask the site owner to add you.
            </div>
          </div>
        )}
        {error && (
          <div className="mt-6 border border-red-500/40 bg-red-500/10 text-red-200 p-4 text-sm" data-testid="error-msg">
            Something went wrong. Please try again.
          </div>
        )}

        <button
          onClick={startGoogleLogin}
          data-testid="google-signin-btn"
          className="mt-8 w-full bg-white text-atc-black px-6 py-4 font-heading uppercase tracking-widest text-sm font-bold border-2 border-white hover:bg-atc-red hover:text-white hover:border-atc-red transition-all flex items-center justify-center gap-3"
        >
          <GoogleLogo size={20} weight="bold" /> Continue with Google
        </button>

        <div className="mt-8 pt-6 border-t border-white/10 font-mono text-[10px] uppercase tracking-widest text-white/40">
          Secured · Emergent OAuth · Session 7d
        </div>
      </div>
    </div>
  );
}
